import { AppPropsType } from '../App/types';
import { createContext } from 'react';

export const ShellContext = createContext<AppPropsType | null>(null);

export const ShellProvider = ShellContext.Provider;
